import React from "react";

interface ComingSoonBadgeProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const ComingSoonBadge: React.FC<ComingSoonBadgeProps> = ({
  className = "",
  size = "sm",
}) => {
  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-3 py-1",
    lg: "text-base px-4 py-1.5",
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 font-medium ${sizeClasses[size]} ${className}`}
      title="This feature is coming soon"
    >
      <span className="material-icons text-sm">schedule</span>
      <span>Coming Soon</span>
    </span>
  );
};

export default ComingSoonBadge;

